import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";

import { getAllMonthlySalaryRedux } from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./salary.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllMonthlySalaryRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;
    const { allMonths } = this.props;
    allMonths.map((month) => month.month);

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Salary" parent="expense-history" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid sl-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card sl-card">
                <div className="card-header sl-card-header">
                  <h5 className="sl-card-title">
                    <i className="icofont-bill sl-card-icon"></i>
                    Stuff Salary
                  </h5>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allMonths}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.expenses.monthly,
  };
};

export default connect(mapStateToProps, {
  getAllMonthlySalaryRedux,
})(MonthlyExpense);
